import { Injectable } from '@angular/core';
import { BaseHubConnection } from './base-hub-connection.service';
import { TagPropertyWrapper } from './models/tag-property-wrapper.model';
import { BehaviorSubject } from 'rxjs';
import { GlobalVariablesService } from '../global-variables.service';
import { HubConnectionState } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class PropertyHubConnectionService extends BaseHubConnection {

  private propertyUpdatedSubject: BehaviorSubject<TagPropertyWrapper> = new BehaviorSubject<TagPropertyWrapper>(null);
  public propertyUpdated$ = this.propertyUpdatedSubject.asObservable();
  private hubUrlCandidates: string[] = [];
  private activeHubUrlIndex = 0;


  constructor(private globals: GlobalVariablesService) {
    super();




  }
  public init() {
    this.hubUrlCandidates = [
      this.globals.buildTrackerUrl('/property-hub'),
    ];
    this.activeHubUrlIndex = 0;
    this.initializeHubConnection(this.hubUrlCandidates[this.activeHubUrlIndex], this.webSocketOnlyOptions({ withCredentials: true }));
    this.connectionStatus.subscribe((status) => {

    }
    );
    this.bindPropertyUpdatedHandler();
  }

  private bindPropertyUpdatedHandler(): void {
    this.hubConnection.off('PropertyUpdated');
    this.hubConnection.on("PropertyUpdated", (data: any) => {

      const property = new TagPropertyWrapper(data);
      this.propertyUpdatedSubject.next(property);
    });
  }

  public override async startConnection() {
    if (!this.hubUrlCandidates.length) {
      this.init();
    }

    for (let index = this.activeHubUrlIndex; index < this.hubUrlCandidates.length; index++) {
      this.activeHubUrlIndex = index;
      this.initializeHubConnection(this.hubUrlCandidates[index], this.webSocketOnlyOptions({ withCredentials: true }));
      this.bindPropertyUpdatedHandler();
      await super.startConnection();

      if (this.currentState === HubConnectionState.Connected) {
        return;
      }
    }
  }

}
